<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 shadow-none"
    :class="''"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
    style="
    margin-left: 0!importnant;
    margin-right: 0!important;
    width: 100%;
    background-color: #2C1F1C;
    height: 4.875rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index:20;
    "
  >
    <div class="px-3 container-fluid">
      <div class="navbar-left-section">
        <!-- 햄버거 메뉴 버튼 (모바일에서만 표시) -->
        <button
          class="mobile-menu-btn"
          @click="toggleMobileSidenav"
          aria-label="메뉴 열기"
        >
          <span class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <img
          class="navbar-logo"
          src="../../assets/img/certilife_logo_radius.png"
          alt=""
        />
        <span class="navbar-title">
          CertiLife 운영 페이지
        </span>
      </div>
        <div
          v-if="this.$store.state.userName"
          class="pe-md-3 d-flex align-items-center"
          :class="'ms-md-auto display-flex'"
        >
        <div class="user-section">
          <!-- 지원 접속 검색(10-29) — 회사 목록을 찾아가지 않고 바로 -->
          <support-quick-entry />
          <span class="user-name">{{ this.$store.state.userName }}</span>
          <!-- 운영자 본인 2차 인증 수단(휴대폰·이메일) 등록·변경·삭제(REQ-ACC-012) -->
          <button
            class="btn btn-outline-light logout-btn my-security-btn"
            @click="mySecurityOpen = true"
          >
            내 계정 보안
          </button>
          <button
            class="btn btn-primary logout-btn"
            @click="clearStorage"
          >
            Logout
          </button>
        </div>
        </div>
    </div>
    <my-security-modal :open="mySecurityOpen" @close="mySecurityOpen = false" />
  </nav>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
import MySecurityModal from "./MySecurityModal.vue";
import SupportQuickEntry from "./SupportQuickEntry.vue";
import { logoutRequestConfig } from "@/utils/consoleRefresh";


export default {
  name: "navbar",
  data() {
    return {
      showMenu: false,
      mySecurityOpen: false,
      userName: "",
      userImageUrl: ""
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
  },
  mounted() {
    this.userName = localStorage.getItem('userNameCerti');
    this.userImageUrl = localStorage.getItem('userImageUrlCerti');
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleMobileSidenav"]),
    ...mapActions(["toggleSidebarColor"]),

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    click() {
      const aside = document.getElementById("sidenav-main");
      if (aside.style.left == 0 || aside.style.left == "0px") {
        aside.style.left = "280px";
      } else {
        aside.style.left = 0;
      }
    },
    async clearStorage() {
      // 서버가 refresh 쿠키를 지우게 먼저 로그아웃(실패해도 화면 로그아웃은 함 — K-19)
      await this.$apiInstance.post("/auth/logout", null, logoutRequestConfig()).catch(() => {});
      await this.$store.dispatch('clearLocalStorage');
      this.$router.push({ name: "signIn" });
    },
  },
  components: {
    MySecurityModal,
    SupportQuickEntry,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped>
/* 네비게이션 컨테이너 */
.container-fluid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}

/* 모바일 브레이크포인트: 767px 이하 */
.navbar-left-section {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 1;
  min-width: 0;
}

.navbar-logo {
  width: 45px;
  height: 45px;
}

.navbar-title {
  color: white;
  font-size: 24px;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 햄버거 메뉴 버튼 - 기본적으로 숨김 (PC) */
.mobile-menu-btn {
  display: none;
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  margin-right: 8px;
}

.hamburger-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
}

.hamburger-icon span {
  display: block;
  width: 100%;
  height: 3px;
  background-color: white;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* 모바일에서 햄버거 메뉴 표시 */
@media screen and (max-width: 767px) {
  .mobile-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .navbar-logo {
    width: 36px;
    height: 36px;
  }

  .navbar-title {
    font-size: 16px;
    margin-left: 6px;
  }
}

/* 태블릿 */
@media screen and (min-width: 768px) and (max-width: 1199px) {
  .navbar-title {
    font-size: 20px;
  }
}

/* 사용자 섹션 스타일 */
.user-section {
  max-height: 50px;
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0; /* 사용자 섹션은 축소되지 않음 */
}

.user-name {
  color: white;
  white-space: nowrap;
}

.logout-btn {
  margin-bottom: 0 !important;
  white-space: nowrap;
}

/* 모바일에서 사용자 섹션 조정 */
@media screen and (max-width: 767px) {
  .user-section {
    font-size: 14px;
    gap: 8px;
  }

  .user-name {
    display: none; /* 모바일에서 사용자명 숨김 */
  }

  .logout-btn {
    padding: 6px 12px !important;
    font-size: 12px !important;
  }
}
</style>
